/** Hostnames de desenvolvimento local — não entram em métricas de produção */
export function isLocalDevHost(hostname: string | null | undefined): boolean {
  if (!hostname?.trim()) return false;
  const host = hostname.toLowerCase().split(":")[0];
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host === "[::1]" ||
    host.endsWith(".localhost")
  );
}

export function isCurrentLocalDevHost(): boolean {
  if (typeof window === "undefined") return false;
  return isLocalDevHost(window.location.hostname);
}
